<template>
  <v-alert
    colored-border
    :color="cardStyle.color"
    border="top"
    elevation="2"
    :icon="cardStyle.icon"
    prominent
  >
    <v-row v-if="loading" justify="center">
      <v-progress-circular indeterminate width="2" />
    </v-row>
    <div v-else>
      <div v-if="!running" class="subheading grey--text text--darken-2">
        Next Run
      </div>
      <div v-if="running" class="headline">Running</div>
      <div v-else-if="time" class="headline">{{ time | date }}</div>
      <div v-else class="headline">No sync scheduled</div>
    </div>
  </v-alert>
</template>

<script>
import { cardStyle } from '../lib/colors';
import moment from 'moment';

export default {
  props: {
    scheduled: { type: Array },
    loading: { type: Boolean },
  },
  computed: {
    cardStyle() {
      return cardStyle(this.loading, this.itsOk);
    },
    valid() {
      return this.time
        ? moment().diff(moment(this.time), 'minutes') < 0
        : false;
    },
    time() {
      return this.scheduled && this.scheduled.length
        ? this.scheduled[0].time
        : undefined;
    },
    running() {
      return this.time && !this.valid;
    },
    itsOk() {
      return this.valid || this.running;
    },
  },
};
</script>
